/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_NewInputs */

const en_lessons_new = /** @type {(inputs: Lessons_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lesson`)
};

const he_lessons_new = /** @type {(inputs: Lessons_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור חדש`)
};

/**
* | output |
* | --- |
* | "New lesson" |
*
* @param {Lessons_NewInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_new = /** @type {((inputs?: Lessons_NewInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_NewInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_new(inputs)
	return he_lessons_new(inputs)
});